import { render, staticRenderFns } from "./RootHeader.vue?vue&type=template&id=2e51cd1e&scoped=true&"
import script from "./RootHeader.vue?vue&type=script&lang=js&"
export * from "./RootHeader.vue?vue&type=script&lang=js&"
import style0 from "./RootHeader.vue?vue&type=style&index=0&id=2e51cd1e&prod&lang=scss&"
import style1 from "./RootHeader.vue?vue&type=style&index=1&id=2e51cd1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51cd1e",
  null
  
)

export default component.exports